module.exports = __webpack_public_path__ + "img/manual.c84400db.svg";